import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3 {...{
      "id": "frontend-sdks"
    }}>{`Frontend SDKs`}</h3>
    <p>{`We make a request to fetch feature flags (using the `}<a parentName="p" {...{
        "href": "/docs/api/decide"
      }}><inlineCode parentName="a">{`/decide`}</inlineCode>{` endpoint`}</a>{`) when:`}</p>
    <ol>
      <li parentName="ol">{`The PostHog SDK is initialized`}</li>
      <li parentName="ol">{`A user is `}<a parentName="li" {...{
          "href": "/docs/data/identify"
        }}>{`identified`}</a>{` `}</li>
      <li parentName="ol">{`A user's `}<a parentName="li" {...{
          "href": "/docs/product-analytics/person-properties"
        }}>{`properties`}</a>{` are updated.`}</li>
      <li parentName="ol">{`You call `}<inlineCode parentName="li">{`posthog.reloadFeatureFlags()`}</inlineCode>{` in your code.`}</li>
    </ol>
    <p>{`For the `}<a parentName="p" {...{
        "href": "/docs/libraries/js"
      }}>{`JavaScript web SDK`}</a>{`, you can estimate how many feature flag requests you will make by doing the following:`}</p>
    <ol>
      <li parentName="ol">{`Check the networks tab in Chrome inspector tools for the number of `}<inlineCode parentName="li">{`/decide`}</inlineCode>{` requests.`}</li>
      <li parentName="ol">{`Find out your number of monthly page views`}</li>
      <li parentName="ol">{`Multiply your number of `}<inlineCode parentName="li">{`/decide`}</inlineCode>{` requests by your monthly page views`}</li>
    </ol>
    <p>{`For example, if on refresh, you see 2 `}<inlineCode parentName="p">{`/decide`}</inlineCode>{` requests per pageview and you have ~150,000 pageviews, your monthly feature flag requests should be around ~300,000.`}</p>
    <h3 {...{
      "id": "backend-sdks"
    }}>{`Backend SDKS`}</h3>
    <h4 {...{
      "id": "without-local-evaluation"
    }}>{`Without local evaluation`}</h4>
    <p>{`If you're not using `}<a parentName="p" {...{
        "href": "/docs/feature-flags/local-evaluation"
      }}>{`local evaluation`}</a>{`, a request to get feature flags is made every time you call `}<inlineCode parentName="p">{`posthog.get_feature_flag()`}</inlineCode>{` on your backend. Your estimated usage will be however many times you are calling this code.`}</p>
    <h4 {...{
      "id": "with-local-evaluation"
    }}>{`With local evaluation`}</h4>
    <p>{`If you're using `}<a parentName="p" {...{
        "href": "/docs/feature-flags/local-evaluation"
      }}>{`local evaluation`}</a>{`, each local evaluation request charges 10 credits and by default are made every 30 seconds. Assuming your server is constantly running and making 2 requests per minute, you will be charged `}<inlineCode parentName="p">{`10 * 2 * 60 * 24 * 30 = 864,000 credits`}</inlineCode>{` each month.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` This figure is for a single server and a single instance of PostHog. If you have multiple servers, PostHog instances, or a different poll duration, you need to multiply your estimates too.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      